import { Link } from "react-router-dom";

export const SiteFooter = () => (
  <footer className="border-t border-slate-800 bg-[#060A12] mt-12" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 py-8 space-y-4 text-xs text-slate-400">
      <div className="rounded-lg border border-amber-500/40 bg-amber-500/5 px-4 py-3 text-amber-100" data-testid="footer-gambling-message">
        <span className="font-bold">18+ only. Chances are you're about to lose.</span>{" "}
        For free and confidential support call the National Gambling Helpline on{" "}
        <a href="tel:1800858858" className="font-bold underline hover:text-white" data-testid="footer-gambling-hotline">1800 858 858</a>{" "}
        or visit{" "}
        <a href="https://www.gamblinghelponline.org.au" target="_blank" rel="noreferrer" className="underline hover:text-white" data-testid="footer-gambling-link">gamblinghelponline.org.au</a>.
        Ratings and prices are a guide only and are not betting advice.
      </div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <span>© {new Date().getFullYear()} Strategic Racing • ABN 52 047 318 854</span>
        <nav className="flex gap-4">
          <Link to="/contact" className="hover:text-white transition-colors" data-testid="footer-contact-link">Contact &amp; Support</Link>
          <Link to="/contact#privacy" className="hover:text-white transition-colors" data-testid="footer-privacy-link">Privacy</Link>
          <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms-link">Terms</Link>
        </nav>
      </div>
    </div>
  </footer>
);
